import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, Skeleton, Typography } from 'antd';
import { Amount, RunningBalance } from '~/types';
import AmountField from './fields/AmountField';

interface Props {
  balances: RunningBalance[];
  loading?: boolean;
}

const Balances: FC<Props> = ({ balances, loading }) => {
  const [t] = useTranslation('accounts');
  const [td] = useTranslation();

  const columns = [
    {
      title: t('balance'),
      dataIndex: 'code',
      key: 'code',
      render: (code: string) => td(code),
    },
    {
      title: t('amount'),
      dataIndex: 'amount',
      key: 'amount',
      render: (amount: Amount) => <AmountField amount={amount} />,
    },
  ];
  if (!balances || balances?.length === 0) return null;
  return (
    <div>
      <Typography.Title level={5}>{t('balancesHeader')}</Typography.Title>
      {loading ? (
        <Skeleton active paragraph={{ rows: 4 }} />
      ) : (
        <Table
          columns={columns}
          dataSource={balances}
          rowKey={(record) => record?.code}
          pagination={false}
          style={{ maxWidth: 420 }}
        />
      )}
    </div>
  );
};

export default Balances;
